/* eslint no-class-assign:off */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Hammer from 'react-hammerjs';
import * as actions from '../actions';
import { getModalImage } from '../reducers';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.handleSwipe = this.handleSwipe.bind(this);
  }
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyPress);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress);
  }
  onKeyPress({ keyCode }) { //eslint-disable-line
    const { changeModalImage } = this.props;
    const { closeModal } = this.props;
    switch (keyCode) {
      case 39:
        changeModalImage('next');
        break;
      case 37:
        changeModalImage('prev');
        break;
      case 27:
        closeModal();
        break;
      default:
        return false;
    }
  }
  handleSwipe(event) {
    const { changeModalImage } = this.props;
    if (event.deltaX > 0) { // swipe right === prev
      changeModalImage('prev');
    } else { // swipe left === next
      changeModalImage('next');
    }
  }
  componentWillUpdate({ image }) { //eslint-disable-line
    switch (image.active) {
      case true:
        document.body.classList.add('modal-is-active');
        break;
      default:
        document.body.classList.remove('modal-is-active');
        break;
    }
  }
  render() {
    const { image, background, changeModalImage, closeModal } = this.props;
    const style = {
      backgroundColor: background,
    };
    const imageStyle = {
      backgroundImage: `url("${image.url}")`,
    };
    if (image.active) {
      return (
        <Hammer onSwipe={this.handleSwipe} direction="DIRECTION_HORIZONTAL">
          <div className="c-modal">
            <div style={style} className="c-modal__backdrop" />
            <div className="c-modal__inner">
              <button
                onClick={closeModal}
                className="btn btn--text btn__close-modal"
              >&times;</button>
              <div className="c-modal__controls">
                <button
                  onClick={() => { changeModalImage('next'); }}
                  className="btn--text c-modal__controls__btn c-modal__controls__btn--next"
                >&gt;</button>
                <button
                  onClick={() => { changeModalImage('prev'); }}
                  className="btn--text c-modal__controls__btn c-modal__controls__btn--prev"
                >&lt;</button>
              </div>
              <div className="c-modal__image" style={imageStyle} />
              <p className="c-modal__caption">{image.caption}</p>
            </div>
          </div>
        </Hammer>
      );
    }
    return null;
  }
}

Modal.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    caption: PropTypes.string,
    active: PropTypes.bool,
  }).isRequired,
  background: PropTypes.string.isRequired,
  changeModalImage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  image: getModalImage(state),
});

Modal = connect(
  mapStateToProps,
  actions,
)(Modal);

export default Modal;



// WEBPACK FOOTER //
// ./js/containers/Modal.js